import Serializer from "../../serializer";
import { TexHelperModel } from "./models";
import { JSONAPIDocument } from "json-api-serializer";
import { IMSTArray } from "mobx-state-tree";

export function deserializeTexHelpers(data: JSONAPIDocument): IMSTArray<typeof TexHelperModel> {
	return Serializer.deserialize("tex_helpers", data);
}
